import script from "./LiveWatchHud.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveWatchHud.vue?vue&type=script&setup=true&lang=ts"

import "./LiveWatchHud.vue?vue&type=style&index=0&id=3826fa97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3826fa97"]])

export default __exports__